module.exports = __webpack_public_path__ + "static/media/dcc.99823dbd.png";